module.exports = __webpack_public_path__ + "assets/img/26_1587.8e942efe.jpg";